(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-halloween-conversion"]) return;
  try {
    
  const initializeHalloweenConversion = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const stickyButton = root.querySelector('[data-mm-sticky-button]');
    const mainButton = document.querySelector('product-form .product-form__submit');
    if (!stickyButton || !mainButton) return;

    let ticking = false;

    const syncButton = () => {
      const unavailable = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      const mainLabel = mainButton.querySelector('span');
      const stickyLabel = stickyButton.querySelector('span');
      stickyButton.disabled = unavailable;
      if (mainLabel && stickyLabel) stickyLabel.textContent = mainLabel.textContent.trim();
    };

    const updateVisibility = () => {
      const passedMainButton = mainButton.getBoundingClientRect().bottom < 0;
      const modalOpen = Boolean(document.querySelector('product-modal[open]'));
      root.classList.toggle('is-visible', passedMainButton && !modalOpen);
      ticking = false;
    };

    const scheduleVisibilityUpdate = () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateVisibility);
    };

    stickyButton.addEventListener('click', () => {
      syncButton();
      if (!stickyButton.disabled) mainButton.click();
    });

    document.addEventListener('change', () => window.requestAnimationFrame(syncButton));
    window.addEventListener('scroll', scheduleVisibilityUpdate, { passive: true });
    window.addEventListener('resize', scheduleVisibilityUpdate, { passive: true });

    const buttonObserver = new MutationObserver(syncButton);
    buttonObserver.observe(mainButton, { attributes: true, childList: true, subtree: true });

    const prefetchProductLinks = () => {
      const connection = navigator.connection;
      if (connection && (connection.saveData || /(^|-)2g$/.test(connection.effectiveType || ''))) return;

      const seen = new Set();
      document.querySelectorAll('.product__description a[href^="/products/"]').forEach((link) => {
        const targetUrl = new URL(link.href);
        if (seen.size >= 3 || seen.has(link.href) || targetUrl.pathname === window.location.pathname) return;
        seen.add(link.href);
        const prefetch = document.createElement('link');
        prefetch.rel = 'prefetch';
        prefetch.href = link.href;
        document.head.appendChild(prefetch);
      });
    };

    syncButton();
    updateVisibility();
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(prefetchProductLinks, { timeout: 2500 });
    } else {
      window.setTimeout(prefetchProductLinks, 1200);
    }
  };

  document.querySelectorAll('[data-mm-sticky-cart]').forEach(initializeHalloweenConversion);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-mm-sticky-cart]').forEach(initializeHalloweenConversion);
  });

  } catch(e) { console.error(e); }
})();
})();
